"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
/******************************************** HELPERS *********************************************/
/**
 * Banner factory
 */
var buildBanner = function (bannerJson) {
    return new javelin_exports_1.Banner(bannerJson.bannerId, bannerJson.name, bannerJson.priority || 0, bannerJson.links, bannerJson.compositeImageURLs, bannerJson.backgroundImageURLs, bannerJson.foregroundImageURLs, bannerJson.filters);
};
/********************* BUILD BANNER+FILTER OBJECTS FROM PROVIDED BANNER DATA **********************/
/**
 * Build collection of banners using banner & filter data arrays
 */
exports.bannerCollectionFactory = function (bannerData, filterData) {
    // Ensure all bannerData items have a filters property
    bannerData.forEach(function (banner) { return (banner.filters = []); });
    // Add Filter items to bannerData
    filterData.forEach(function (filter) {
        var curFilter = new javelin_exports_1.Filter(filter.filterId.toString(), filter.bannerId, 'FIXME', filter.type, filter.value);
        for (var _i = 0, bannerData_1 = bannerData; _i < bannerData_1.length; _i++) {
            var banner = bannerData_1[_i];
            if (banner.bannerId === filter.bannerId) {
                banner.filters.push(curFilter);
                break;
            }
        }
    });
    return bannerData.map(buildBanner);
};
//# sourceMappingURL=banners.js.map